import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { newCastleConfig } from "./data";

export default function NewCastlePage() {
  return <CityPageTemplate config={newCastleConfig} />;
}